import { useState, useEffect } from 'react'

import { hbuWhite,hbuColor } from '../../assets/image/index.js';
import './headers.css'
import { 
  Container,
  Navbar,
  Nav,
  NavDropdown,
  Form,
  Button,
  Image,

} from 'react-bootstrap';

const Headers = () => {

  const [pos, setPos] = useState("bg-body-teriary navbar-headers fixed-top pt-0 navbar")
  const [iconBrand, setIcon] =useState(hbuWhite)

  useEffect (()=>{
      document.addEventListener("scroll", e => {
          let scrolled = document.scrollingElement.scrollTop;
          if (scrolled >= 600){
            setPos(" bg-body-teriary navbar-headers fixed-top pt-0 navbar navbar-moved")
            setIcon(hbuColor)
          } else {
            setPos(" bg-body-teriary navbar-headers fixed-top pt-0 navbar")
            setIcon(hbuWhite)
          }
      })
  },[])

  return (
    <Navbar expand="lg" className={pos}
    // className='bg-body-teriary navbar-headers fixed-top pt-0 navbar' 
    // style={{backgroundColor: pos === "top" ? "rgba(0, 0, 0, 0)" : "rgba(0, 0, 0, .5)" }}
    >
      <Container>
        <Navbar.Brand>
          <Image className='d-block' width={150} 
            alt="HBU Express Logo"
            src={iconBrand} ></Image>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll navbar-light" />
        <Navbar.Collapse className="justify-content-end">
          <Nav className="link">
            <Nav.Link href="#home">Beranda</Nav.Link>
            <Nav.Link href="#action1">Tentang Kami</Nav.Link>
            <Nav.Link href="#action2">Layanan</Nav.Link>
            <Nav.Link href="#action2">Kontak</Nav.Link>
          </Nav>
        </Navbar.Collapse>        
      </Container>
    </Navbar>
  )
}

export default Headers